import { rem } from '@mantine/core'

export default {
  xs: rem(12),
  sm: rem(14),
  md: rem(16),
  lg: rem(20),
  xl: rem(24),
  '2xl': rem(32),
  '3xl': rem(36),
  '4xl': rem(40),
  '5xl': rem(48),
  '6xl': rem(60)
}
